// extracted by mini-css-extract-plugin
module.exports = {"backgroundGrid":"author_backgroundGrid__MVn3X"};